import { render, staticRenderFns } from "./avatar-image.vue?vue&type=template&id=e1c7c05c&scoped=true&"
import script from "./avatar-image.vue?vue&type=script&lang=js&"
export * from "./avatar-image.vue?vue&type=script&lang=js&"
import style0 from "./avatar-image.vue?vue&type=style&index=0&id=e1c7c05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c7c05c",
  null
  
)

export default component.exports